const _ = require("lodash");

const getGlobalData = () => {
	return global && global.window && global.window.RUNTIME_TRAINER_DATA;
};

const getBlockBeasts = () => _.get(getGlobalData(), "blockBeasts", {});
const getChapterBlocks = () => _.get(getGlobalData(), "chapterBlocks", []);
const getPuzzleBlocks = () => _.get(getGlobalData(), "puzzleBlocks", []);

module.exports = {
	getBlockBeasts,
	getChapterBlocks,
	getPuzzleBlocks,
};
